@if (currentCity$ | async; as currentCity) {
  <sd-city-defined-confirmation [cityName]="currentCity.name"></sd-city-defined-confirmation>
  <button data-testid="citySelectBtn" class="link-white link-hover-orange button" (click)="onOpenCityList($event)">
    <sd-icon
      class="icon-size-xxs icon-size-md-s"
      [type]="isMobileMenu ? iconTypes.LOCATION_FILLED : iconTypes.LOCATION"
    ></sd-icon>
    <span class="text-b3-s-500 text-md-b2-s-500 current-city">
      {{ currentCity.name }}
    </span>
    @if (!currentCity.inDeliveryZone) {
      <sd-icon class="icon-size-s icon-size-md-m" [type]="iconTypes.LOCATION_WARNING"></sd-icon>
    }
  </button>
} @else {
  <span>Загрузка...</span>
}
